module.exports = __webpack_public_path__ + "assets/img/cSharpIcon.342f6801.svg";